import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Junta classes resolvendo CONFLITO de utilitário Tailwind.
 *
 * O `cx` anterior era uma concatenação simples, então `<Card className="p-6">` num Card que já
 * traz `p-4` gerava as duas classes e o resultado dependia da ordem no CSS final — bug de layout
 * intermitente. Com `twMerge`, a última classe vence de forma previsível: quem chama o componente
 * sempre consegue sobrescrever.
 */
export function cx(...entradas: ClassValue[]): string {
  return twMerge(clsx(entradas));
}

export default cx;
